import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import useStyle from 'isomorphic-style-loader/useStyles';
import { AlertsBus } from 'modules/App';
import Header from './Header';
import styles from './MobilePage.pcss';
const MobilePage = ({ headerMessage, backToRouteName, className, onClick, children, queryParameters = '' })=>{
    useStyle(styles);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.mobilePage, className),
        children: [
            /*#__PURE__*/ _jsx(Header, {
                message: headerMessage,
                backToRouteName: backToRouteName,
                onClick: onClick,
                queryParameters: queryParameters
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "content__list",
                children: [
                    /*#__PURE__*/ _jsx(AlertsBus, {
                        className: "mt-5"
                    }),
                    children
                ]
            })
        ]
    });
};
export default MobilePage;
